/*
 * Copyright (c) GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import { createEntity } from 'jotai/entity';
import { SystemWorkspaceId, systemWorkspaceIdSlug } from '../SystemWorkspaceId';
import { WorkspaceObject } from '../WorkspaceObject';
import { OriginType, RunType } from 'models/viewModels';

export const defaultTest: WorkspaceObject = {
  id: SystemWorkspaceId.DefaultTest,
  name: 'Default Test',
  slug: systemWorkspaceIdSlug.defaultTest,
  owner: 'system',
  sessionTypes: [RunType.PRACTICE, RunType.QUALIFYING, RunType.RACE],
  activeView: 't1',
  views: {
    byId: {
      t1: { id: 't1', name: 'Combined Views', visualizations: ['v1', 'v2', 'v3', 'v4'], layouts: 'vl1' },
    },
    allIds: ['t1'],
  },
  viewLayouts: {
    byId: {
      vl1: [
        { i: 'v1', w: 2, h: 29, x: 0, y: 0 },
        { i: 'v2', w: 10, h: 13, x: 2, y: 0 },
        { i: 'v3', w: 10, h: 16, x: 2, y: 13 },
        { i: 'v4', w: 12, h: 9, x: 0, y: 29 },
      ],
    },
    allIds: ['vl1'],
  },
  visualizations: {
    byId: {
      v1: { id: 'v1', name: 'Race Order Table', type: 'raceOrderTable', settings: 'vs1' },
      v2: { id: 'v2', name: 'Lap Times Table', type: 'lapTimesTable', settings: 'vs2' },
      v3: { id: 'v3', name: 'Lap Times Graph', type: 'lapTimesGraph', settings: 'vs3' },
      v4: { id: 'v4', name: 'Running Order Table', type: 'runningOrderTable', settings: 'vs4' },
    },
    allIds: ['v1', 'v2', 'v3', 'v4'],
  },
  visualizationSettings: {
    byId: {
      vs1: {
        id: 'vs1',
        columnStates: [
          { colId: 'runningposition', sort: 'asc', width: 50 },
          { colId: 'vehiclenumber', width: 50 },
          { colId: 'driverfullname', hide: true, flex: 1 },
          { colId: 'lapscompleted', width: 50 },
          { colId: 'deltatotarget', flex: 1 },
          { colId: 'lapsled', width: 50 },
          { colId: 'lastlaptime', flex: 1 },
          { colId: 'bestlaptime', flex: 1 },
          { colId: 'movingaveragelaptime', hide: true, flex: 1 },
          { colId: 'runName', hide: true, flex: 1 },
          { colId: 'ppLap', hide: true, flex: 1 },
          { colId: 'ppStrat', hide: true, flex: 1 },
        ],
        localVehicleSelections: {
          useLocalSelections: false,
          selectedGroup: 'none',
          selectedOems: [],
          selectedPerformances: [],
          selectedPlayoffDrivers: 'none',
          selectedPlayoffTopDrivers: 'none',
          selectedLeader: 'leaderOnly',
          individualSelections: [],
        },
        dataFeedSelections: OriginType.RMONITOR,
      },
      vs2: {
        id: 'vs2',
        localVehicleSelections: {
          useLocalSelections: false,
          selectedGroup: 'none',
          selectedOems: [],
          selectedPerformances: [],
          selectedPlayoffTopDrivers: 'none',
          selectedPlayoffDrivers: 'none',
          selectedLeader: 'leaderOnly',
          individualSelections: [],
        },
        dataFeedSelections: OriginType.RMONITOR,
      },
      vs3: {
        id: 'vs3',
        lapsFrom: 1,
        lapsAutoIncrement: false,
        localVehicleSelections: {
          useLocalSelections: false,
          selectedGroup: 'none',
          selectedOems: [],
          selectedPerformances: [],
          selectedPlayoffTopDrivers: 'none',
          selectedPlayoffDrivers: 'none',
          selectedLeader: 'leaderOnly',
          individualSelections: [],
        },
        dataFeedSelections: OriginType.RMONITOR,
      },
      vs4: {
        id: 'vs4',
        localVehicleSelections: {
          useLocalSelections: false,
          selectedGroup: 'none',
          selectedOems: [],
          selectedPerformances: [],
          selectedPlayoffTopDrivers: 'none',
          selectedPlayoffDrivers: 'none',
          selectedLeader: 'leaderOnly',
          individualSelections: [],
        },
        dataFeedSelections: OriginType.RMONITOR,
      },
    },
    allIds: ['vs1', 'vs2', 'vs3', 'vs4'],
  },
  selectedCompetitorGroups: {},
  competitorGroups: createEntity(),
  competitorGroupVehicles: createEntity(),
  selectedReferenceVehicle: createEntity(),
  hideFooter: false,
  trackMapSettings: createEntity(),
};
